import { postRequest, putRequest, replaceInUrl } from './index';
import apiEndpoints from './apiEndpoints';

export const createPersonNameRequest = ({ ApplicationUid, data, isPrimary }) =>
  postRequest(
    replaceInUrl(apiEndpoints.persons.postPersonName, {
      ApplicationUid,
    }),
    data,
    { isPrimary },
  );

export const updatePersonNameRequest = ({ ApplicationUid, PersonUid, data }) =>
  putRequest(
    replaceInUrl(apiEndpoints.persons.putPersonName, {
      ApplicationUid,
      PersonUid,
    }),
    data,
  );

export const createPersonSSNRequest = ({ ApplicationUid, PersonUid, data }) =>
  postRequest(
    replaceInUrl(apiEndpoints.persons.postPersonSSN, {
      ApplicationUid,
      PersonUid,
    }),
    data,
  );

export const updatePersonSSNRequest = ({ ApplicationUid, PersonUid, data }) =>
  putRequest(
    replaceInUrl(apiEndpoints.persons.putPersonSSN, {
      ApplicationUid,
      PersonUid,
    }),
    data,
  );

export const createPersonAddressRequest = ({
  ApplicationUid,
  PersonUid,
  data,
}) =>
  postRequest(
    replaceInUrl(apiEndpoints.persons.postPersonAddress, {
      ApplicationUid,
      PersonUid,
    }),
    data,
  );

export const updatePersonAddressRequest = ({
  ApplicationUid,
  PersonUid,
  data,
}) =>
  putRequest(
    replaceInUrl(apiEndpoints.persons.putPersonAddress, {
      ApplicationUid,
      PersonUid,
    }),
    data,
  );

export const createPersonBirthdayRequest = ({
  ApplicationUid,
  PersonUid,
  data,
}) =>
  postRequest(
    replaceInUrl(apiEndpoints.persons.postPersonBirthday, {
      ApplicationUid,
      PersonUid,
    }),
    data,
  );

export const updatePersonBirthdayRequest = ({
  ApplicationUid,
  PersonUid,
  data,
}) =>
  putRequest(
    replaceInUrl(apiEndpoints.persons.putPersonBirthday, {
      ApplicationUid,
      PersonUid,
    }),
    data,
  );

export const createPersonCountryRequest = ({
  ApplicationUid,
  PersonUid,
  data,
}) =>
  postRequest(
    replaceInUrl(apiEndpoints.persons.postPersonCountry, {
      ApplicationUid,
      PersonUid,
    }),
    data,
  );

export const updatePersonCountryRequest = ({
  ApplicationUid,
  PersonUid,
  data,
}) =>
  putRequest(
    replaceInUrl(apiEndpoints.persons.putPersonCountry, {
      ApplicationUid,
      PersonUid,
    }),
    data,
  );

export const createPersonBackupWithHoldingsRequest = ({
  ApplicationUid,
  PersonTargetType,
  data,
}) => {
  const queryParams = { PersonTargetType };
  return postRequest(
    replaceInUrl(apiEndpoints.persons.postPersonBackupHoldings, {
      ApplicationUid,
    }),
    data,
    queryParams,
  );
};

export const updatePersonBackupWithHoldingsRequest = ({
  ApplicationUid,
  PersonTargetType,
  data,
}) => {
  const queryParams = { PersonTargetType };

  return putRequest(
    replaceInUrl(apiEndpoints.persons.putPersonBackupHoldings, {
      ApplicationUid,
    }),
    data,
    queryParams,
  );
};

export const createPersonPhoneRequest = ({ ApplicationUid, PersonUid, data }) =>
  postRequest(
    replaceInUrl(apiEndpoints.persons.postPersonPhone, {
      ApplicationUid,
      PersonUid,
    }),
    data,
  );

export const updatePersonPhoneRequest = ({ ApplicationUid, PersonUid, data }) =>
  putRequest(
    replaceInUrl(apiEndpoints.persons.putPersonPhone, {
      ApplicationUid,
      PersonUid,
    }),
    data,
  );
export const createLegalEntityNameRequest = ({ ApplicationUid, data }) =>
  postRequest(
    replaceInUrl(apiEndpoints.persons.postLegalEntityName, {
      ApplicationUid,
    }),
    data,
  );

export const updateLegalEntityNameRequest = ({ ApplicationUid, data }) =>
  putRequest(
    replaceInUrl(apiEndpoints.persons.putLegalEntityName, {
      ApplicationUid,
    }),
    data,
  );

export const createLegalEntityEinRequest = ({ ApplicationUid, data }) =>
  postRequest(
    replaceInUrl(apiEndpoints.persons.postLegalEntityEin, {
      ApplicationUid,
    }),
    data,
  );

export const updateLegalEntityEinRequest = ({ ApplicationUid, data }) =>
  putRequest(
    replaceInUrl(apiEndpoints.persons.putLegalEntityEin, {
      ApplicationUid,
    }),
    data,
  );

export const createLegalEntityAddressRequest = ({ ApplicationUid, data }) =>
  postRequest(
    replaceInUrl(apiEndpoints.persons.postLegalEntityAddress, {
      ApplicationUid,
    }),
    data,
  );

export const updateLegalEntityAddressRequest = ({ ApplicationUid, data }) =>
  putRequest(
    replaceInUrl(apiEndpoints.persons.putLegalEntityAddress, {
      ApplicationUid,
    }),
    data,
  );

export const createPersonMartialStatusRequest = ({
  ApplicationUid,
  PersonUid,
  data,
}) =>
  postRequest(
    replaceInUrl(apiEndpoints.persons.maritalStatus, {
      ApplicationUid,
      PersonUid,
    }),
    data,
  );

export const updatePersonMartialStatusRequest = ({
  ApplicationUid,
  PersonUid,
  data,
}) =>
  putRequest(
    replaceInUrl(apiEndpoints.persons.maritalStatus, {
      ApplicationUid,
      PersonUid,
    }),
    data,
  );
